import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { manageClassUsersCrudStateConfig } from "../../../../consts";

const manageUsersMetaReducer = makeCrudStateReducer(
  manageClassUsersCrudStateConfig
);
export default manageUsersMetaReducer;
